export default __webpack_public_path__ + "static/media/project2.7feeb152.jpg";